import React from "react";
import PropTypes from "prop-types";

import Button, { ButtonPropTypes } from "ui/Button";

import useCheckPermissions from "hooks/useCheckPermissions";

const PermissionButton = (props) => {
  const checkPermission = useCheckPermissions();
  const { permission, children, ...otherProps } = props;

  if (!checkPermission(permission)) return null;

  return <Button {...otherProps}>{children}</Button>;
};

PermissionButton.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.any,
  ...ButtonPropTypes,
};

export default PermissionButton;
